<p>revoke-permissions works!</p>
